import { CounterRepository } from '../../repositories/CounterRepository';
import { StoresRepository } from '../../repositories/StoresRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';

export class StoresHydrateService {
    private storesRepository: StoresRepository;
    private counterRepository: CounterRepository;

    constructor() {
        this.counterRepository = diContainer.get(serviceNames.counterRepository);
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
    }

    public hydrateStoresWithCountersData() {
        this.storesRepository.stores.forEach((store) => {
            const matchingCounter = Object.values(this.counterRepository.counters).find(
                (counter) => counter.storeNumber === store.jdaStoreNumber
            );
            matchingCounter &&
                store.update({
                    canBookAppointments: matchingCounter.hasServicesAvailable
                });
        });
    }
}
